import type { RowData } from "@tanstack/react-table";
import { withCurrentReturnContext } from "@/lib/navigation/return-context";
import type { RecordObjectDef } from "./types";

export function canPersistViewsFor(
  object: { capabilities: { views?: boolean } },
  savedViewObjectType: string | undefined,
  override: boolean | undefined,
): boolean {
  if (override === false) return false;
  return (
    object.capabilities.views === true && savedViewObjectType !== undefined
  );
}

export function emptyCopy(
  label: string,
  hasFilters: boolean,
  copy: {
    emptyTitle?: string;
    emptyDescription?: string;
    filteredEmpty?: { title: string; description: string };
  },
) {
  const noun = label.toLowerCase();
  if (hasFilters) {
    return {
      emptyTitle: copy.filteredEmpty?.title ?? `No ${noun} match these filters.`,
      emptyDescription: copy.filteredEmpty?.description,
    };
  }
  return {
    emptyTitle: copy.emptyTitle ?? `No ${noun} yet.`,
    emptyDescription: copy.emptyDescription,
  };
}

export function openRecordWith<TData extends RowData>(
  object: RecordObjectDef<TData>,
  navigate: (href: string) => void,
) {
  return (row: TData) => {
    if (!object.getRowHref) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          `Record object "${object.id}" invoked openRecord without getRowHref`,
        );
      }
      return;
    }
    const href = object.getRowHref(row);
    if (href) navigate(withCurrentReturnContext(href));
  };
}

export function getClientPageRowCount(
  totalRows: number,
  page: number,
  pageSize: number,
) {
  const remainingRows = totalRows - (page - 1) * pageSize;
  return Math.max(0, Math.min(pageSize, remainingRows));
}
